module.exports = __webpack_public_path__ + "img/kolor-10.377b6be2.png";